import { render, staticRenderFns } from "./BodySkeletonLoader.vue?vue&type=template&id=40933831"
import script from "./BodySkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./BodySkeletonLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports